import React, { useEffect, useRef, useState } from 'react';

export default function PassSlider() {
  const originalPosters = Array.from(
    { length: 17 },
    (_, i) => `/images/pass/poster${String(i + 1).padStart(2, '0')}.png`
  );

  const [posters, setPosters] = useState(originalPosters);
  const trackRef = useRef(null);
  const trackCloneRef = useRef(null);
  const positionRef = useRef(0);
  const speedRef = useRef(0.042);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    // 슬라이드를 2배 복제해 무한 스크롤 버그 방지
    setPosters(prev => [...prev, ...prev]);
  }, []);

  const animate = () => {
    positionRef.current -= speedRef.current;
    if (positionRef.current <= -100) {
      positionRef.current = 0;
    }

    if (trackRef.current && trackCloneRef.current) {
      trackRef.current.style.transform = `translateX(${positionRef.current}%)`;
      trackCloneRef.current.style.transform = `translateX(${positionRef.current + 100}%)`;
    }

    animationFrameRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    // 초기 위치 설정
    if (trackRef.current && trackCloneRef.current) {
      trackRef.current.style.transform = 'translateX(0%)';
      trackCloneRef.current.style.transform = 'translateX(100%)';
    }

    // 애니메이션 시작
    animate();

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);

  return (
    <>
      <div className="passSectionTitleWrap_type4">
        <em className="passSectionTitle">
          이 모든 채널<br />
          <em>SBS play 이용권</em> 하나면 충분해요!
        </em>
      </div>

      <div className="slider-type01">
        <div className="slider">
          {/* 원본 트랙 */}
          <div className="slide-track" ref={trackRef}>
            {originalPosters.map((src, idx) => (
              <div className="slide" key={idx}>
                <img src={src} alt={`poster${idx + 1}`} />
              </div>
            ))}
          </div>

          {/* 복제된 트랙 */}
          <div className="slide-track" ref={trackCloneRef}>
            {originalPosters.map((src, idx) => (
              <div className="slide" key={`clone-${idx}`}>
                <img src={src} alt={`poster${idx + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}